









































import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { IClearanceApproval } from "@/models/clearance-approval.entity";
import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";
import { formatCurrency } from "@/lib/utility/currency-helper";

@Component({
  components: { Tooltip },
  filters: { simpleDoubleDigitDate }
})
export default class RefsClearanceApproval extends BaseRef<IClearanceApproval>
  implements IRefDetail<IClearanceApproval> {
  readonly RefsTypeMap = RefTypeMap;
  readonly formatCurrency = formatCurrency;

  @Prop()
  item!: IClearanceApproval;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  goToDetail() {
    this.item.goTo(this.$router).detail();
  }

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }
}
